var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruthfulCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9297 18.2148C34.9297 27.4462 27.4462 34.9297 18.2148 34.9297C8.98348 34.9297 1.5 27.4462 1.5 18.2148C1.5 8.98348 8.98348 1.5 18.2148 1.5C27.4462 1.5 34.9297 8.98348 34.9297 18.2148Z",
    stroke: "#81C240",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruthfulCircle);
export default __webpack_public_path__ + "static/media/truthful-circle.0a7f3cfc4bdff5aa606abfd691c44f4c.svg";
export { ForwardRef as ReactComponent };